import React from "react";
import styled from "styled-components";

const RecommendationsContainer = styled.div`
  margin: 40px 0;
  background-color: #f8f9fa;
  border-radius: 0;
  padding: 30px;
`;

const RecommendationsTitle = styled.h2`
  font-size: 22px;
  color: #333;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  gap: 10px;
`;

const RecommendationsList = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 20px;
`;

const RecommendationCard = styled.div`
  background: white;
  border-radius: 0;
  padding: 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  border-left: 4px solid ${(props) => props.color || "#6ed216"};
`;

const RecommendationIcon = styled.div`
  font-size: 24px;
  margin-bottom: 10px;
`;

const RecommendationTitle = styled.h3`
  font-size: 16px;
  font-weight: 600;
  color: #333;
  margin-bottom: 8px;
`;

const RecommendationText = styled.p`
  font-size: 14px;
  color: #666;
  line-height: 1.5;
  margin-bottom: 12px;
`;

const RecommendationAction = styled.div`
  font-size: 13px;
  color: #6ed216;
  font-weight: 500;
  background-color: #f0fdf4;
  padding: 8px 12px;
  border-radius: 0;
`;

function CampaignRecommendations({
  smsData,
  emailData,
  smsClickToPreviewRate,
  emailClickToOpenRate,
  emailOpenRate,
}) {
  const generateRecommendations = () => {
    const recommendations = [];

    // Recommandations SMS
    if (smsData) {
      if (parseFloat(smsClickToPreviewRate) < 3) {
        recommendations.push({
          icon: "📱",
          title: "Optimiser vos SMS",
          text: "Votre taux de clic SMS peut être amélioré. Testez des messages plus courts avec des call-to-action plus percutants.",
          action: "Prochaine campagne: Tester des SMS de 80 caractères max",
          color: "#ff9800",
        });
      } else {
        recommendations.push({
          icon: "🎯",
          title: "Excellent engagement SMS",
          text: "Vos SMS performent très bien ! Continuez avec cette approche et testez des volumes plus importants.",
          action:
            "Recommandation: Augmenter le volume de 25% sur la prochaine campagne",
          color: "#4caf50",
        });
      }
    }

    // Recommandations Email
    if (emailData) {
      if (parseFloat(emailOpenRate) < 20) {
        recommendations.push({
          icon: "✉️",
          title: "Améliorer l'ouverture Email",
          text: "Vos objets d'email peuvent être optimisés. Testez des objets plus personnalisés et évitez les mots spam.",
          action: "Prochaine campagne: A/B tester 3 objets différents",
          color: "#ff9800",
        });
      }

      if (parseFloat(emailClickToOpenRate) > 15) {
        recommendations.push({
          icon: "🚀",
          title: "Contenu Email performant",
          text: "Excellent taux de clic ! Votre contenu engage bien vos lecteurs. Dupliquez cette approche.",
          action:
            "Recommandation: Réutiliser ce template pour vos prochaines campagnes",
          color: "#4caf50",
        });
      }
    }

    // Recommandations générales
    recommendations.push({
      icon: "🎨",
      title: "Optimisation Créative",
      text: "Testez des visuels avec des couleurs contrastées et des CTA plus visibles. Les créas avec visages humains performent +25%.",
      action: "Prochaine campagne: A/B tester 3 créas différentes",
      color: "#6ed216",
    });

    recommendations.push({
      icon: "📱",
      title: "Format Mobile-First",
      text: "80% des ouvertures se font sur mobile. Optimisez vos créas pour les petits écrans avec des textes plus gros.",
      action: "Recommandation: Créas optimisées mobile 375px max",
      color: "#94a3b8",
    });

    recommendations.push({
      icon: "⏰",
      title: "Timing Optimal",
      text: "Les meilleures performances sont entre 10h-11h et 14h-15h en semaine. Évitez les envois le vendredi après-midi.",
      action: "Prochaine campagne: Programmer pour mardi 10h30",
      color: "#94a3b8",
    });

    return recommendations;
  };

  const recommendations = generateRecommendations();

  return (
    <RecommendationsContainer>
      <RecommendationsTitle>
        💡 Conseils pour Optimiser vos Prochaines Campagnes
      </RecommendationsTitle>

      <RecommendationsList>
        {recommendations.map((rec, index) => (
          <RecommendationCard key={index} color={rec.color}>
            <RecommendationIcon>{rec.icon}</RecommendationIcon>
            <RecommendationTitle>{rec.title}</RecommendationTitle>
            <RecommendationText>{rec.text}</RecommendationText>
            <RecommendationAction>{rec.action}</RecommendationAction>
          </RecommendationCard>
        ))}
      </RecommendationsList>
    </RecommendationsContainer>
  );
}

export default CampaignRecommendations;
